import { PlaidAccountOwner } from '../../interfaces';

export const getNumberOfAccountOwners = (plaidAccountOwners: PlaidAccountOwner[]): number => {
  if (!plaidAccountOwners || plaidAccountOwners.length === 0) return null;

  if (plaidAccountOwners.some((item) => !item.name)) return null;

  return plaidAccountOwners.length;
};
